import script from "./confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm.vue?vue&type=script&setup=true&lang=js"

import "./confirm.vue?vue&type=style&index=0&id=37c76f76&lang=scss"

const __exports__ = script;

export default __exports__